import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ApiError } from '../../lib/api/types/common';

type TKey = string | number;
export function useQueryWithConfig<T>(
  key: TKey[],
  fetcher: () => Promise<T>,
  options?: Omit<UseQueryOptions<T, AxiosError<ApiError>>, 'queryKey' | 'queryFn'>
) {
  return useQuery<T, AxiosError<ApiError>>({
    queryKey: key,
    queryFn: fetcher,
    staleTime: 0, // 5 minutes
    refetchOnWindowFocus: true,
    ...options,
  });
}